import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncDocumentUploadLater = loadable(
  () => import('./DocumentUploadLater'),
  {
    fallback: <Loader />,
  },
);
